import type { Session, AuthChangeEvent } from '@supabase/supabase-js';
import { getSupabase } from './client';

export async function signInWithPassword(email: string, password: string) {
  return getSupabase().auth.signInWithPassword({ email, password });
}

export async function signUp(email: string, password: string) {
  return getSupabase().auth.signUp({ email, password });
}

export async function signOut() {
  return getSupabase().auth.signOut();
}

export async function getSession(): Promise<Session | null> {
  const { data } = await getSupabase().auth.getSession();
  return data.session;
}

export type AuthCallback = (event: AuthChangeEvent, session: Session | null) => void;

export function onAuthChange(cb: AuthCallback): () => void {
  const { data } = getSupabase().auth.onAuthStateChange(cb);
  return () => data.subscription.unsubscribe();
}
